<template>
    <div class="layout-process-list" :class="menuVisible ? 'layout-visible': ''">
        <!--s: Search 区域-->
        <div class="device-list-search-config">
            <div class="device-list-select">
                <div class="box">
<!--                    <div class="box-list">-->
<!--                        <span class="label">时间：</span>-->
<!--                        <Select v-model="processListParams.sortType" clearable style="width: 100px">-->
<!--                            <Option v-for="(date,key) in processDate" :value="date.value" :key="key">{{ date.label }}</Option>-->
<!--                        </Select>-->
<!--                    </div>-->
                    <div class="box-list">
                        <span class="label">发布状态：</span>
                        <Select v-model="processListParams.status" clearable style="width: 100px">
                            <Option v-for="(status,key) in processStatus" :value="status.value" :key="key">{{ status.label }}</Option>
                        </Select>
                    </div>
                    <div class="box-list">
                        <Button @click="onReset" style="margin-left: 10px">重置</Button>
                        <Button type="primary" @click="onSearch">查询</Button>
                    </div>
                </div>
                <div class="box">
                  <Checkbox
                    v-model="checkAll"
                    @on-change="handleCheckAll" style="margin-right: 10px">一键全选</Checkbox>
                    <Button icon="ios-share-alt" @click="onExport">批量导出</Button>
                    <Button icon="ios-download">导入
                        <input type="file" :ref="`dataInputer${0}`" accept="application/zip" multiple="multiple" class="file" @change="onFileDataChange($event,0)">
                    </Button>
                    <Button type="primary" icon="ios-add" @click="onAddList">新建</Button>
                </div>
            </div>
        </div>
        <!--e: Search 区域-->
        <!--s: Data 区域-->
        <div class="process-list">
            <div class="box" :style="'height:'+processHeight+'px'">
                <CheckboxGroup v-model="checkAllGroup" @on-change="checkAllGroupChange">
                <ul>
                    <li :key='key' v-for="(processList,key) in processListArray.content">
                        <div class="process-card" @click="onEditLinks(processList)">
                            <ul>
                                <li>流程编号：{{ processList.flowCode }} <font class="badge" :class="processList.status === 0?'red':'green'">{{ processList.status === 0?'未发布':'已发布' }}</font></li>
                                <li>创建日期：{{ processList.createTime }}</li>
                                <li>创建人：{{ processList.createUser }}</li>
                                <li>任务引用：{{ processList.useNum }}</li>
                            </ul>
                            <div class="edit" v-if="processList.publishUseNum === 0" @click.stop>
                                <Dropdown placement="bottom-end">
                                    <a href="javascript:void(0)" class="edit-size">
                                        <Icon type="ios-more"></Icon>
                                    </a>
                                    <DropdownMenu slot="list">
<!--                                        <DropdownItem v-if="processList.useNum > 0" @click.native="onEditLinks(processList)">查看</DropdownItem>-->
                                        <DropdownItem v-if="processList.publishUseNum < 1 && processList.status === 0" @click.native="onUpdateNameStatus(key,processList)">重命名</DropdownItem>
                                        <DropdownItem v-if="processList.status === 0" @click.native="onEditLinks(processList)">编辑</DropdownItem>
                                        <DropdownItem v-if="processList.status === 0" @click.native="onDelete(processList)">删除</DropdownItem>
                                        <DropdownItem v-if="processList.publishUseNum < 1 && processList.status === 1"  @click.native="onRelease(processList.id,0)">撤回</DropdownItem>
                                        <DropdownItem v-if="processList.status === 0"  @click.native="onRelease(processList.id,1)">发布</DropdownItem>
                                        <DropdownItem @click.native="onExportId(processList.id)">导出</DropdownItem>
                                    </DropdownMenu>
                                </Dropdown>
                            </div>
                            <div class="card-check" @click.stop><Checkbox size="large" :label="processList.id"></Checkbox></div>
                        </div>
                        <div class="card-name-box">
                            <p class="name" v-if="!processList.nameStatus">{{ processList.flowName }}</p>
                            <Input ref="flowName" v-model="processList.flowName" maxlength="20" v-if="processList.nameStatus" @on-blur="onUpdateName(processList.id,key)" @on-enter="$event.target.blur()" placeholder="请输入工作流名称" class="name" />
                        </div>
                    </li>
                </ul>
                </CheckboxGroup>
                <Spin fix v-if="processLoading"></Spin>
            </div>
            <div class="device-list-page" v-if="processListArray.content && processListArray.content.length !== 0">
                <Page :total="processListArray.totalSize" :current="processListArray.currentPage" show-total show-sizer size="small" :page-size="processListParams.displayNumber" :page-size-opts="[6,9,12,15]" @on-change="onSearchPage" @on-page-size-change="onSearchPageSize"/>
            </div>
        </div>
        <!--e: Data 区域-->
        <!--s: 上传进度-->
        <Modal
          title="上传进度"
          v-model="speedVisible"
          footer-hide
          :mask-closable="false"
          :closable="false">
          <div class="progress-info">
            <div class="info-li" :key="key" v-for="(speed,key) in speedList">
              <span class="name">{{ speed.name }}</span>
              <span class="size">{{ (speed.size / 1024 / 1024).toFixed(2) }}M</span>
            </div>
          </div>
          <div class="progress-box">
            <div class="progress-outer">
              <div class="progress-inner">
                <div class="progress-bg" :class="completeAsync<100?'before':''" :style="'width: '+completeAsync+'%; height: 10px;'"></div>
              </div>
              <div class="progress-text">{{ completeAsync }}%</div>
            </div>
          </div>
          <div class="device-footer">
            <Button type="primary" v-if="completeAsync === 100" @click="speedVisible = false;completeAsync = 0">关闭</Button>
          </div>
        </Modal>
        <!--e: 上传进度-->
    </div>
</template>
<script>
import ProcessList from './list'
export default ProcessList
</script>
<style lang="less">
@import "list";
</style>
